import * as React from "react";
import { Translate } from "react-localize-redux";
import { translationKeys } from "../../../../gen/translation-keys";
import FormTextField from "../../../ui-components/forms/controls/FormTextField";
import { EditProfileKeys } from "./EditProfileForm";

interface NameFormFieldProps {
  disabled?: boolean;
  fieldName: EditProfileKeys;
  label?: React.ReactNode;
}
const NameFormField: React.FC<NameFormFieldProps> = ({
  disabled,
  fieldName,
  label
}) => {
  return (
    <Translate>
      {({ translate }) => (
        <FormTextField
          label={label}
          fieldName={fieldName}
          fullWidth
          fieldOptions={{
            required: translate(
              translationKeys.account.my_profile_form_to_name_required
            ).toString(),
            maxLength: {
              value: 250,
              message: translate(
                translationKeys.account.my_profile_form_name_too_long
              ).toString()
            }
          }}
          disabled={disabled}
        />
      )}
    </Translate>
  );
};

export default NameFormField;
